import { h, render, Component } from 'preact';

import { Router } from 'preact-router';
import { Link } from 'preact-router/match';

const MenuLink = ({href, label}) => (
  <Link activeClassName='menu--active' href={href}>{label}</Link>
);

class GalleryWidget extends Component {

    constructor(props) {
        super();

        this.state = {
            current: null
        };
    }

    closeOverlay() {
        this.setState({current: null});
    }

    move(d) {
        const images = this.props.images;
        this.setState({
            current: images[images.indexOf(this.state.current)+d]
        });
    }
    next(e) {
        e.stopPropagation();
        this.move(1);
    }
    prev(e) {
        e.stopPropagation();
        this.move(-1);
    }

    render({images, style}) {

        const c = this.state.current;
        const idx = images.indexOf(c);
        const n = idx < (images.length-1);
        const p = idx > 0;

        return (
            <div>
                <div class='overlay' style={c ? {
                        opacity: 1.0,
                        pointerEvents: 'auto'
                    } : {}}>
                    <div onClick={()=>this.closeOverlay()}>
                        {c && <img src={c.img} onClick={(e)=>this.next(e)}/>}
                        <div class='gallery-button close' onClick={()=>this.closeOverlay()}>&#10005;</div>
                        { n && <div class='gallery-button next'  onClick={(e)=>this.next(e)}>&#8811;</div>}
                        { p && <div class='gallery-button prev'  onClick={(e)=>this.prev(e)}>&#8810;</div>}
                    </div>
                </div>
                <div class='gallery' style={style}>
                {
                    images.map(
                        e=>(
                            <div onClick={
                                ()=>{
                                    this.setState({current: e});}
                            }><img src={e.thumb}/></div>
                        )
                    )
                }
                </div>
            </div>
        );
    }
};





import gallery from './images/gallery';
const Gallery = ()=>(<GalleryWidget images={gallery} style={{flexWrap: 'wrap'}}/>);


import nauen from './images/Nauen';
import geschichtspark from './images/Geschichtspark';
import grenzstreifen from './images/Grenzstreifen';
import woltersdorf from './images/Woltersdorf';
import pankow from './images/Pankow';

const Person = ()=>(
  <div class="person">
      <h1>Arbeiten in der Öffentlichkeit</h1>
      <div>
        <h3>Berlin</h3>
        <div>
            Relief für Werner Prochnow / Greifenhagener Str.
        </div>
        <div>Großes Holzkreuz, Holzgestaltung mit Text und Relief aus Holz,
            Ton und Jerusalemer Stein – Freikirche Berlin-Pankow
            <GalleryWidget images={pankow}/>
        </div>
        <div>Erinnerungsmal an die Zwangsarbeiter in der Rüstungsindustrie –
             Zement/Sandstein/Bronze
        </div>
        <div>Farbfenstergestaltung und Holzkreuz Freikirche Berlin – Woltersdorf
            <GalleryWidget images={woltersdorf}/>
        </div>
    </div>
    <div>
      <h3>Nauen</h3>
      <div>Sandsteinfigur „Der Mahner“ Jüdischer Friedhof</div>
      <div>
          Bronzerelief an der ehemaligen Synagoge Nauen
          <GalleryWidget images={nauen}/>
      </div>
    </div>
    <div>
      <h3>Rathenow</h3>
      <div>Sandsteinfigurengruppe „Mitmenschlichkeit“</div>
    </div>
    <div>
      <h3>Falkensee</h3>
      <div>Holzstelen im Grenzstreifen
          <GalleryWidget images={grenzstreifen}/>
      </div>
      <div>Holzarbeit zur Erinnerung an die Flucht von drei Jugendlichen 1988</div>
      <div>Geschichtspark
          <GalleryWidget images={geschichtspark}/>
      </div>
    </div>
    <h1>Lebenslauf</h1>
    <table class='cv'>
        <tr><td>26.01.1953</td><td>geboren in Hennigsdorf bei Berlin</td></tr>
        <tr><td>1971</td><td>Abitur</td></tr>
        <tr><td>1973-75</td><td>Studium Medizin Humboldt-Uni Berlin</td></tr>
        <tr><td>1975-78</td><td>Arbeit am Anatomischen Institut der HU-Berlin.</td></tr>
        <tr><td>1978-83</td><td>	Studium an der Kunsthochschule Berlin-Weißensee</td></tr>
        <tr><td></td><td>Diplom bei Prof. Jo Jastram</td></tr>
        <tr><td>1983-86</td><td>	Förderstipendium Magistrat von Berlin</td></tr>
        <tr><td>1983-90</td><td>	Freischaffender Bildhauer</td></tr>
        <tr><td>seit 1985</td><td>	wohnhaft in Falkensee bei Berlin</td></tr>
        <tr><td>1990-95</td><td>	Leiter des Heimatmuseums</td></tr>
        <tr><td>1990</td><td>	Mitgründer des Creativen Zentrums „Haus am Anger“ Falkensee</td></tr>
        <tr><td>seit 1992</td><td>	Leiter des Creatives Zentrums „Haus am Anger“ Falkensee,<br/> seit 2017 Anerkannte Jugendkunstschule des Landes Brandenburg und im Jugendkunstschulverband</td></tr>
        <tr><td>seit 1994</td><td>	Jugendaustausch mit Israel</td></tr>
        <tr><td>1994 -2005</td><td> mit Maalot</td></tr>
        <tr><td>seit 2006</td><td> mit Haifa, Synagoge „Or Hadash“</td></tr>
    </table>
    <h1>Teilnahme an Symposien</h1>
    <table class='cv'>
        <tr><td>1984 und 1986</td><td>
            Steinbildhauersymposium<br/>
            Rainhardsdorf / Sächsische Schweiz
        </td></tr>
        <tr><td>1996</td><td>Rathenow</td></tr>

    </table>
    <h1>Ausstellungen</h1>
    <p>
    Berlin, Nauen, Rathenow, Falkensee, Binz / Rügen, Hamburg<br/>
    Theologische Hochschule Friedensau bei Burg,<br/>
    Haifa /Israel
    </p>
</div>
);

const Kontakt = () => (
    <div>
        <p>
            Ingo Wellmann<br/>
            Pestalozzistr. 118<br/>
            14612 Falkensee<br/>
        </p>
        <p>
            <a href='mailto:ingowellmann.falkensee@gmail.com'>ingowellmann.falkensee@gmail.com</a><br/>
            <a href='mailto:wellmann@creatives-zentrum.de'>wellmann@creatives-zentrum.de</a><br/>
        </p>
    </div>
)

const Main = () => (
  <div>
    <div className='menu'>
      <MenuLink href='/' label='Zur Person'/>
      <MenuLink href='/gallerie' label='Gallerie'/>
      <MenuLink href='/kontakt' label='Kontakt'/>
    </div>
    <div className='content'>
        <Router>
            <Person default/>
            <Gallery path='/gallerie'/>
            <Kontakt path='/kontakt'/>
        </Router>
    </div>
  </div>
);


render(<Main/>, window.document.getElementById('app'));
